module.exports = __webpack_public_path__ + "img/KS.16688cf1.png";